import { render } from "./OnDemandBodyType.vue?vue&type=template&id=57c71a91"
import script from "./OnDemandBodyType.vue?vue&type=script&lang=js"
export * from "./OnDemandBodyType.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__